import React, { useState, useEffect } from 'react';
import { GetAuth } from '../../Auth/AuthProvider';
// import { NoHeaderTableUpdate } from '../../Helpers/requests';
import { r2_noHeaderTableUpdate } from '../../Helpers/r2_requests';

import UnauthorisedAccess from '../CommonComponents/UnauthorisedAccess';

import ExportToCsv from '../../Helpers/CsvExport';

import { DataGrid } from '@mui/x-data-grid';
import { Box, Grid, Typography, Modal, Button } from '@mui/material';

// import UsersAutocomplete from '../CommonComponents/UsersAutocomplete';
// import TechAutocomplete from '../CommonComponents/TechAutocomplete';
import DatePicker from '../CommonComponents/DatePicker';

import { gridStyle } from './gridStyle';

import CircleIcon from '@mui/icons-material/Circle';
import { changeFirstToUpper } from '../../Helpers/helpers';

const TicketingReport = () => {
  // const [loggedData, setLoggedData] = useState([]);
  // const [loggedPage, setLoggedPage] = useState(0);

  const [totalTickets, setTotalTickets] = useState([]);
  const [totalTicketsSort, setTotalTicketsSort] = useState([]);
  const [totalTicketsPage, setTotalTicketsPage] = useState(0);

  const [dashboardStatus, setDashboardStatus] = useState([]);
  const [dashboardStatusSort, setDashboardStatusSort] = useState([]);
  const [dashboardStatusPage, setDashboardStatusPage] = useState(0);

  const [ticketsPerRegion, setTicketsPerRegion] = useState([]);
  const [ticketsPerRegionSort, setTicketsPerRegionSort] = useState([]);
  const [ticketsPerRegionPage, setTicketsPerRegionPage] = useState(0);

  const [responsePerCategory, setResponsePerCategory] = useState([]);
  const [responsePerCategorySort, setResponsePerCategorySort] = useState([]);
  const [responsePerCategoryPage, setResponsePerCategoryPage] = useState(0);

  const [ticketTimesPerTechType, setTicketTimesPerTechType] = useState([]);
  const [ticketTimesPerTechTypeSort, setTicketTimesPerTechTypeSort] = useState(
    []
  );
  const [ticketTimesPerTechTypePage, setTicketTimesPerTechTypePage] =
    useState(0);

  const [ticketsPerTech, setTicketsPerTech] = useState([]);
  const [ticketsPerTechSort, setTicketsPerTechSort] = useState([]);
  const [ticketsPerTechPage, setTicketsPerTechPage] = useState(0);

  const [customerFeedback, setCustomerFeedback] = useState([]);
  const [customerFeedbackSort, setCustomerFeedbackSort] = useState([]);
  const [customerFeedbackPage, setCustomerFeedbackPage] = useState(0);

  const [invoiceType, setInvoiceType] = useState([]);
  const [invoiceTypeSort, setInvoiceTypeSort] = useState([]);
  const [invoiceTypePage, setInvoiceTypePage] = useState(0);

  const [perCabinet, setPerCabinet] = useState([]);
  const [perCabinetSort, setPerCabinetSort] = useState([]);
  const [perCabinetPage, setPerCabinetPage] = useState(0);

  const [perRepairInvoice, setPerRepairInvoice] = useState([]);
  const [perRepairInvoiceSort, setPerRepairInvoiceSort] = useState([]);
  const [perRepairInvoicePage, setPerRepairInvoicePage] = useState(0);

  const [timesPerRegion, setTimesPerRegion] = useState([]);
  const [timesPerRegionSort, setTimesPerRegionSort] = useState([]);
  const [timesPerRegionPage, setTimesPerRegionPage] = useState(0);

  const [loggedPageSize, setLoggedPageSize] = useState(25);
  const [loggedSort, setLoggedSort] = useState([]);
  const [loggedFilter, setLoggedFilter] = useState([]);
  const [loggedTotalRows, setLoggedTotalRows] = useState(0);

  const [data, setData] = useState([]);
  // const [forceUpdate, setForceUpdate] = useState(1);

  const [totalRows, setTotalRows] = useState(0);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(25);
  const [filter, setFilter] = useState([]);
  const [sort, setSort] = useState([]);
  const [loading, setLoading] = useState(false);
  const enqNotification = GetAuth().Notification;
  const logout = GetAuth().signOut;
  const [updateData, setUpdateData] = useState(0);

  //FILTERS
  // const [techSelected, setTechSelected] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  const [fullFilterBlob, setFullFilterBlob] = useState([]);
  const [rangeFilterBlob, setRangeFilterBlob] = useState([]);
  const [useType, setUseType] = useState(localStorage.getItem('type'));
  const [rowData, setRowData] = useState({});

  const [techId, setTechId] = useState(null);

  const padLeft = (intVal) => {
    return intVal < 10 ? `0${intVal}` : intVal;
  };

  const handleRangeChange = (data, type) => {
    let startTime = startDate;
    let endTime = endDate;
    let oldData = [...rangeFilterBlob];

    switch (type) {
      case 'start_time':
        startTime = data;

        let currentDate = new Date();
        let dateString = `${currentDate.getFullYear()}-${padLeft(
          currentDate.getMonth() + 1
        )}-${padLeft(currentDate.getDate())} 23:59:59`;

        let tempStartData = oldData
          .slice()
          .filter((item) => item.field !== 'start_time');

        data === '%'
          ? setRangeFilterBlob([...tempStartData])
          : setRangeFilterBlob([
              ...tempStartData,
              {
                field: 'start_time',
                start: data + ' 00:00:00',
                stop: dateString,
              },
            ]);
        setStartDate(data);
        break;
      case 'stop_time':
        endTime = data;
        let firstDate = new Date(0);

        let dateString1 = `${firstDate.getFullYear()}-${padLeft(
          firstDate.getMonth() + 1
        )}-${padLeft(firstDate.getDate())} 00:00:00`;

        let tempEndData = oldData
          .slice()
          .filter((item) => item.field !== 'stop_time');

        data === '%'
          ? setRangeFilterBlob([...tempEndData])
          : setRangeFilterBlob([
              ...tempEndData,
              {
                field: 'stop_time',
                start: dateString1,
                stop: data + ' 23:59:59',
              },
            ]);
        setEndDate(data);
        break;
      default:
        break;
    }
  };

  const handelDate = (date, subVal) => {
    const inDate = date;
    // let outDate = inDate.substring(0, inDate.lastIndexOf('T') + 1);
    // outDate = outDate + subVal;
    // console.log(`Date: ${date} \nSubval: ${subVal} \nOutDate:`);
    return date;
  };

  const handleClearDateRange = () => {
    if (rangeFilterBlob.length > 0) {
      setRangeFilterBlob([]);
      const newDate = new Date();
      setStartDate(newDate);
      setEndDate(newDate);
    }
  };

  useEffect(() => {
    const newDate = new Date();
    setStartDate(newDate);
    setEndDate(newDate);
  }, []);

  const LoadData = (data) => {
    setTotalTickets(data?.total_tickets ?? []);
    setDashboardStatus(data?.dashboard_status ?? []);
    setTicketsPerRegion(data?.tickets_per_regions ?? []);
    setResponsePerCategory(data?.tickets_per_category ?? []);
    setTicketTimesPerTechType(
      data?.repair_tickets_response_time_per_tech ?? []
    );
    setTicketsPerTech(data?.tickets_per_tech ?? []);
    setCustomerFeedback(data?.repair_tickets_customer_feedback ?? []);
    setInvoiceType(data?.repair_tickets_per_invoice_type_analysis ?? []);
    setPerCabinet(data?.repair_tickets_per_cabinet_type ?? []);
    setPerRepairInvoice(data?.repair_tickets_per_invoice_type ?? []);
    setTimesPerRegion(data?.repair_tickets_response_time_per_region ?? []);
  };

  useEffect(() => {
    r2_noHeaderTableUpdate(
      {
        resource: `/api/r2_reports`,
        setDataFunc: LoadData,
        setLoadingFunc: setLoading,
        setRows: setLoggedTotalRows,
        logout,
        startDate: startDate,
        endDate: endDate,
      },
      'ticketing_report'
    );
  }, [startDate, endDate, logout]);

  useEffect(() => {
    r2_noHeaderTableUpdate(
      {
        resource: `/api/r2_constants`,
        setDataFunc: setData,
        pageNum: page,
        setLoadingFunc: setLoading,
        // pagesize: pageSize,
        sorting: sort,
        filtering: filter,
        showNotification: enqNotification,
        setRows: setTotalRows,
        logout,
        fullFilters: [
          {
            field: 'field',
            search: 'CUS_REGIONS',
            strict: true,
          },
        ],
        rangeFilters: [],
      },
      'r2_constants'
    );
  }, []);

  const [data_D, setData_D] = useState([]); //data displayed in datagrid
  const [page_D, setPage_D] = useState(0); //Active page of table - starts at 0!
  const [filter_D, setFilter_D] = useState([]); //Current applied filter modal
  const [sort_D, setSort_D] = useState([]); //Current applied sorting modal
  const [loading_D, setLoading_D] = useState(false); //Loading indicator - used by datagrid
  const [, setActiveRow_D] = useState('NONE'); //Last row clicked - used in details (Detailbox) display
  const [pageSize_D, setPageSize_D] = useState(20); //Number of rows to display
  const [totalRows_D, setTotalRows_D] = useState(0); //Total Number of rows in set
  const [updateData_D, setUpdateData_D] = useState(0); //Increment to force update dataset
  const [repairData, setRepairData] = useState([]);
  const [installData, setInstallData] = useState([]);

  const dashData = (data) => {
    setData_D(data);
    setRepairData(data?.repair_statuses ?? []);
    setInstallData(data?.install_statuses ?? []);
  };
  // useEffect(() => {
  //   r2_noHeaderTableUpdate({
  //     resource: `/api/r2_noticeboard`,
  //     setDataFunc: dashData,
  //     pageNum: page_D,
  //     setLoadingFunc: setLoading_D,
  //     pagesize: pageSize_D,
  //     sorting: sort_D,
  //     filtering: filter_D,
  //     showNotification: enqNotification,
  //     setRows: setTotalRows_D,
  //     logout,
  //   });
  // }, [
  //   page_D,
  //   pageSize_D,
  //   sort_D,
  //   filter_D,
  //   updateData_D,
  //   enqNotification,
  //   logout,
  //   startDate,
  //   endDate,
  // ]);

  const TotalTicketsColumns = [
    {
      field: 'repair',
      headerName: 'Repairs',
      width: 150,
      flex: 1,
    },
    {
      field: 'upliftment',
      headerName: 'Upliftments',
      width: 150,
      flex: 1,
    },
    {
      field: 'install',
      headerName: 'Installations',
      width: 150,
      flex: 1,
    },
    {
      field: 'total',
      headerName: 'Total',
      width: 150,
      flex: 1,
    },
  ];

  const dashboardStatusColumns = [
    {
      field: 'status',
      headerName: 'Status',
      width: 150,
      flex: 1,
      renderCell: (data) => <>{changeFirstToUpper(data.row.statusName)}</>,
    },
    {
      field: 'count',
      headerName: 'Ticket Qty',
      width: 150,
      flex: 1,
    },
  ];
  const ticketPerRegionColumns = [
    {
      field: 'region_name',
      headerName: 'Region',
      width: 150,
      flex: 1,
      type: 'text',
    },
    {
      field: 'technician',
      headerName: 'Technicians',
      width: 150,
      flex: 1,
      type: 'text',
    },
    {
      field: 'subbie',
      headerName: 'Sub Contractors',
      width: 150,
      flex: 1,
      type: 'text',
    },
    {
      field: 'upliftment',
      headerName: 'Upliftments',
      width: 150,
      flex: 1,
      type: 'text',
    },
    {
      field: 'install',
      headerName: 'Installations',
      width: 150,
      flex: 1,
      type: 'text',
    },
    {
      field: 'total',
      headerName: 'Total',
      width: 150,
      flex: 1,
      type: 'text',
      renderCell: (props) => (
        <>
          <Typography>
            {props.row.technician +
              props.row.subbie +
              props.row.upliftment +
              props.row.install}
          </Typography>
        </>
      ),
    },
  ];
  const ticketPerCategoryColumns = [
    {
      field: 'category_name',
      headerName: 'Category',
      width: 150,
      flex: 1,
      type: 'text',
    },
    {
      field: 'repair',
      headerName: 'Repairs',
      width: 150,
      flex: 1,
      type: 'text',
    },
    {
      field: 'upliftment',
      headerName: 'Upliftments',
      width: 150,
      flex: 1,
      type: 'text',
    },
    {
      field: 'install',
      headerName: 'Installations',
      width: 150,
      flex: 1,
      type: 'text',
    },
    {
      field: 'total',
      headerName: 'Total',
      width: 150,
      flex: 1,
      type: 'text',
    },
  ];
  const responseTimePerTechColumns = [
    {
      field: 'period',
      headerName: 'Period',
      width: 150,
      flex: 1,
      type: 'text',
    },
    {
      field: 'technicians',
      headerName: 'Technicians',
      width: 150,
      flex: 1,
      type: 'text',
    },
    {
      field: 'sub_contractors',
      headerName: 'SubContractors',
      width: 150,
      flex: 1,
      type: 'text',
    },
    {
      field: 'total',
      headerName: 'Total',
      width: 150,
      flex: 1,
      type: 'text',
    },
  ];
  const ticketPerTechColumns = [
    {
      field: 'tech_name',
      headerName: 'Tech',
      width: 150,
      flex: 1,
      type: 'text',
    },
    {
      field: 'total_tickets',
      headerName: 'Total Tickets',
      width: 150,
      flex: 1,
      type: 'text',
    },
    {
      field: 'install_tickets',
      headerName: 'Installation Tickets',
      width: 150,
      flex: 1,
      type: 'text',
    },
    {
      field: 'repair_tickets',
      headerName: 'Repair Tickets',
      width: 150,
      flex: 1,
      type: 'text',
    },
    {
      field: 'avg_rating',
      headerName: 'Average Rating',
      width: 150,
      flex: 1,
      type: 'text',
    },
  ];
  const customerFeedbackColumns = [
    {
      field: 'description',
      headerName: 'Description',
      width: 150,
      flex: 1,
      type: 'text',
    },
    {
      field: 'count',
      headerName: 'Total',
      width: 150,
      flex: 1,
      type: 'text',
    },
    {
      field: 'average_percentage',
      headerName: 'Average',
      width: 150,
      flex: 1,
      type: 'text',
      // renderCell: (props) => (
      //   <>
      //     <Typography>{(props.row.count / ) * 100}</Typography>
      //   </>
      // ),
    },
  ];
  const invoiceTypeForRepairColumns = [
    {
      field: 'description',
      headerName: 'Invoice Type',
      width: 150,
      flex: 1,
      type: 'text',
    },
    {
      field: 'count',
      headerName: 'Ticket Qty',
      width: 150,
      flex: 1,
      type: 'text',
    },
    {
      field: 'labour_hrs',
      headerName: 'Labour Hrs',
      width: 150,
      flex: 1,
      type: 'text',
    },
    {
      field: 'travel_time',
      headerName: 'Travel Time',
      width: 150,
      flex: 1,
      type: 'text',
    },
    {
      field: 'travel_km',
      headerName: 'Travel KM',
      width: 150,
      flex: 1,
      type: 'text',
    },
    {
      field: 'total_amt',
      headerName: 'Total Time',
      width: 150,
      flex: 1,
      type: 'text',
    },
    {
      field: 'average_percentage',
      headerName: 'Average',
      width: 150,
      flex: 1,
      type: 'text',
    },
  ];
  const perCabinetTypeRepairColumns = [
    {
      field: 'cabinet_type',
      headerName: 'Cabinet Type',
      width: 150,
      flex: 1,
      type: 'text',
    },
    {
      field: 'count',
      headerName: 'Repair Tickets',
      width: 150,
      flex: 1,
      type: 'text',
    },
  ];
  const perInvoiceTypeRepairColumns = [
    {
      field: 'name',
      headerName: 'Cabinet',
      width: 150,
      flex: 1,
      type: 'text',
    },
    {
      field: 'invoice',
      headerName: 'Invoice Store',
      width: 150,
      flex: 1,
      type: 'text',
    },
    {
      field: 'no_charge',
      headerName: 'No Charge',
      width: 150,
      flex: 1,
      type: 'text',
    },
    {
      field: 'claim_supplier',
      headerName: 'Claim Supplier',
      width: 150,
      flex: 1,
      type: 'text',
    },
    {
      field: 'recall',
      headerName: 'Re-Call',
      width: 150,
      flex: 1,
      type: 'text',
    },
    {
      field: 'warranty',
      headerName: 'Warrantee',
      width: 150,
      flex: 1,
      type: 'text',
    },
  ];

  const regionsColumns = data.map((region) => {
    return {
      field: region.name,
      headerName: region.name,
      width: 120,
      flex: 0,
      type: 'text',
    };
  });

  const regionsColumnsExportHeaders = data.map((region) => {
    return region.name;
  });

  regionsColumnsExportHeaders.unshift('period');

  const RepairTicketsResponseTimePerRegionColumns = [
    {
      field: 'period',
      headerName: 'Period',
      width: 150,
      flex: 0,
      type: 'text',
    },
    ...regionsColumns?.sort((a, b) => (a.field > b.field ? 1 : -1)),
  ];

  return useType !== 'manager' ? (
    <UnauthorisedAccess />
  ) : (
    <Box style={{ height: '65vh', width: 2648 }}>
      <Box maxWidth={1024}>
        <Grid container columnGap={1}>
          <Grid xs={12} md={6} container columnGap={1}>
            <Grid xs={12} md={4}>
              <DatePicker
                dateLabel='Start Date'
                getDate={(data) =>
                  handleRangeChange(handelDate(data, '00:01:01'), 'start_time')
                }
              ></DatePicker>
            </Grid>
            <Grid xs={12} md={4}>
              <DatePicker
                dateLabel='End Date'
                getDate={(data) =>
                  handleRangeChange(handelDate(data, '23:59:59'), 'stop_time')
                }
              ></DatePicker>
            </Grid>
            <Grid xs={12} md={3} sx={{ display: 'flex', alignItems: 'center' }}>
              <Button
                variant='outlined'
                size='large'
                onClick={handleClearDateRange}
              >
                Clear
              </Button>
            </Grid>
          </Grid>
          <Grid xs={12} md={3} sx={{ display: 'flex', alignItems: 'center' }}>
            <Button
              variant='contained'
              size='large'
              type='info'
              onClick={() => {
                new ExportToCsv('ticketing_total_tickets').ExportRawData(
                  totalTickets
                );
                new ExportToCsv('ticketing_dashboard_status').ExportRawData(
                  dashboardStatus
                );
                new ExportToCsv('ticketing_tickets_per_region').ExportRawData(
                  ticketsPerRegion
                );
                new ExportToCsv('ticketing_tickets_per_category').ExportRawData(
                  responsePerCategory
                );
                new ExportToCsv(
                  'ticketing_response_time_per_tech_type'
                ).ExportRawData(ticketTimesPerTechType);
                new ExportToCsv('ticketing_tickets_per_tech').ExportRawData(
                  ticketsPerTech
                );
                new ExportToCsv('ticketing_customer_feedback').ExportRawData(
                  customerFeedback
                );
                new ExportToCsv(
                  'ticketing_invoice_type_for_repair_tickets'
                ).ExportRawData(invoiceType);
                new ExportToCsv(
                  'ticketing_tickets_per_cabinet_type_for_repair_tickets'
                ).ExportRawData(perCabinet);
                new ExportToCsv(
                  'ticketing_tickets_per_invoice_for_repair_tickets'
                ).ExportRawData(perRepairInvoice);
                new ExportToCsv(
                  'ticketing_repair_tickets_response_time_per_region'
                )
                  .OverrideHeaders(
                    regionsColumnsExportHeaders,
                    regionsColumnsExportHeaders
                  )
                  .ExportRawData(timesPerRegion);
              }}
            >
              Extract Data
            </Button>
          </Grid>
        </Grid>
      </Box>
      <Box height='30vh' width='100%'>
        <Grid container columnGap={1} rowGap={1}>
          {' '}
          <Grid item xs={12} align='center'></Grid>
          <Grid item xs={3.85}>
            <Typography
              sx={{ fontWeight: 'bold' }}
              variant='h6'
              height={'3vh'}
              align='center'
              xs={{
                background: '#ebedf8',
                margin: '0 auto',
                width: '100%',
                justifyContent: 'center',
                alignItems: 'center',
                flexGrow: 1,
                textAlign: 'center',
                align: 'center',
              }}
            >
              Total Tickets
            </Typography>
            <DataGrid
              id='total_tickets'
              sx={{
                ...gridStyle,
                width: '100%',
                height: '12vh',
              }}
              hideFooter
              // rows={loggedData}
              rows={totalTickets}
              // getRowId={(row) => row?.tech_id}
              // rowCount={loggedTotalRows}
              // loading={loading}
              pagination
              // sortingMode='server'
              // filterMode='server'
              onSortModelChange={(model) => {
                setTotalTicketsPage(0);
                totalTicketsSort(model);
              }}
              // onFilterModelChange={(model) => {
              //   setLoggedPage(0);
              //   setLoggedFilter(model.quickFilterValues);
              // }}
              page={totalTicketsPage}
              // pageSize={loggedPageSize}
              // initialState={{
              //   pagination: {
              //     paginationModel: { pageSize: 5, page: 0 },
              //   },
              // }}
              // paginationMode='client'
              // onPageChange={(newPage) => {
              //   setTotalTicketsPage(newPage);
              // }}
              // onPageSizeChange={(newPageSize) => {
              //   setLoggedPage(0);
              //   setLoggedPageSize(newPageSize);
              // }}
              columns={TotalTicketsColumns}
              // onRowClick={(params) => {}}
              // rowsPerPageOptions={[25, 50, 100]}
              // components={{ Toolbar: CustomCustomerToolbar }}
              autoPageSize
              // disableColumnFilter
              // disableColumnSelector
              // disableDensitySelector
              // initialState={{
              //   aggregation: {
              //     model: {
              //       calc2: 'sum',
              //       year: 'sum',
              //     },
              //   },
              // }}
              componentsProps={
                {
                  // getRowId: loggedData.tech_id,
                  // toolbar: {
                  //   updateOnclick: () => {
                  //     setUpdateData((i) => i + 1);
                  //   },
                  //   filterOnClick: () => {
                  //     // handleFilterOpen();
                  //   },
                  //   // modalState: modalState,
                  // },
                }
              }
            />
            <Typography
              sx={{ fontWeight: 'bold' }}
              height={'3vh'}
              variant='h6'
              align='center'
              xs={{
                background: '#ebedf8',
                margin: '0 auto',
                width: '100%',
                justifyContent: 'center',
                alignItems: 'center',
                flexGrow: 1,
                textAlign: 'center',
                align: 'center',
              }}
            >
              Dashboard Status
            </Typography>
            <DataGrid
              id='dashboard_status'
              sx={{
                ...gridStyle,
                width: '100%',
                height: '30vh',
              }}
              // rows={loggedData}
              rows={dashboardStatus}
              // getRowId={(row) => row?.tech_id}
              // rowCount={loggedTotalRows}
              // loading={loading}
              pagination
              // sortingMode='server'
              // filterMode='server'
              onSortModelChange={(model) => {
                setDashboardStatusPage(0);
                setDashboardStatusSort(model);
              }}
              // onFilterModelChange={(model) => {
              //   setLoggedPage(0);
              //   setLoggedFilter(model.quickFilterValues);
              // }}
              page={dashboardStatusPage}
              // pageSize={loggedPageSize}
              // initialState={{
              //   pagination: {
              //     paginationModel: { pageSize: 5, page: 0 },
              //   },
              // }}
              // paginationMode='client'
              onPageChange={(newPage) => {
                setDashboardStatusPage(newPage);
              }}
              onPageSizeChange={(newPageSize) => {
                setDashboardStatusPage(0);
                setLoggedPageSize(newPageSize);
              }}
              columns={dashboardStatusColumns}
              onRowClick={(params) => {}}
              // rowsPerPageOptions={[25, 50, 100]}
              // components={{ Toolbar: CustomCustomerToolbar }}
              autoPageSize
              // disableColumnFilter
              // disableColumnSelector
              // disableDensitySelector
              componentsProps={
                {
                  // getRowId: loggedData.tech_id,
                  // toolbar: {
                  //   updateOnclick: () => {
                  //     setUpdateData((i) => i + 1);
                  //   },
                  //   filterOnClick: () => {
                  //     // handleFilterOpen();
                  //   },
                  //   // modalState: modalState,
                  // },
                }
              }
            />
            <Typography
              sx={{ fontWeight: 'bold' }}
              height={'3vh'}
              variant='h6'
              align='center'
              xs={{
                background: '#ebedf8',
                margin: '0 auto',
                width: '100%',
                justifyContent: 'center',
                alignItems: 'center',
                flexGrow: 1,
                textAlign: 'center',
                align: 'center',
              }}
            >
              Tickets Per Region
            </Typography>
            <DataGrid
              id='tickets_per_region'
              sx={{
                ...gridStyle,
                width: '100%',
                height: '30vh',
              }}
              // rows={loggedData}
              rows={ticketsPerRegion}
              // getRowId={(row) => row?.tech_id}
              // rowCount={loggedTotalRows}
              // loading={loading}
              pagination
              // sortingMode='server'
              // filterMode='server'
              onSortModelChange={(model) => {
                setTicketsPerRegionPage(0);
                setTicketsPerRegionSort(model);
              }}
              // onFilterModelChange={(model) => {
              //   setLoggedPage(0);
              //   setLoggedFilter(model.quickFilterValues);
              // }}
              page={ticketsPerRegionPage}
              // pageSize={loggedPageSize}
              // initialState={{
              //   pagination: {
              //     paginationModel: { pageSize: 5, page: 0 },
              //   },
              // }}
              // paginationMode='client'
              onPageChange={(newPage) => {
                setTicketsPerRegionPage(newPage);
              }}
              onPageSizeChange={(newPageSize) => {
                setTicketsPerRegionPage(0);
                setLoggedPageSize(newPageSize);
              }}
              columns={ticketPerRegionColumns}
              // onRowClick={(params) => {}}
              // rowsPerPageOptions={[25, 50, 100]}
              // components={{ Toolbar: CustomCustomerToolbar }}
              autoPageSize
              // disableColumnFilter
              disableColumnSelector
              disableDensitySelector
              componentsProps={
                {
                  // getRowId: loggedData.tech_id,
                  // toolbar: {
                  //   updateOnclick: () => {
                  //     setUpdateData((i) => i + 1);
                  //   },
                  //   filterOnClick: () => {
                  //     // handleFilterOpen();
                  //   },
                  //   // modalState: modalState,
                  // },
                }
              }
            />
            <Typography
              sx={{ fontWeight: 'bold' }}
              height={'3vh'}
              variant='h6'
              align='center'
              xs={{
                background: '#ebedf8',
                margin: '0 auto',
                width: '100%',
                justifyContent: 'center',
                alignItems: 'center',
                flexGrow: 1,
                textAlign: 'center',
                align: 'center',
              }}
            >
              Ticket Per Category
            </Typography>
            <DataGrid
              id='response_per_category'
              sx={{
                ...gridStyle,
                width: '100%',
                height: '30vh',
              }}
              // rows={loggedData}
              rows={responsePerCategory}
              // getRowId={(row) => row?.tech_id}
              // rowCount={loggedTotalRows}
              // loading={loading}
              pagination
              // sortingMode='server'
              // filterMode='server'
              onSortModelChange={(model) => {
                // setLoggedPage(0);
                setLoggedSort(model);
              }}
              // onFilterModelChange={(model) => {
              //   setLoggedPage(0);
              //   setLoggedFilter(model.quickFilterValues);
              // }}
              page={responsePerCategoryPage}
              // pageSize={loggedPageSize}
              // initialState={{
              //   pagination: {
              //     paginationModel: { pageSize: 5, page: 0 },
              //   },
              // }}
              // paginationMode='client'
              onPageChange={(newPage) => {
                setResponsePerCategoryPage(newPage);
              }}
              onPageSizeChange={(newPageSize) => {
                setResponsePerCategoryPage(0);
                setResponsePerCategorySort(newPageSize);
              }}
              columns={ticketPerCategoryColumns}
              // onRowClick={(params) => {}}
              // rowsPerPageOptions={[25, 50, 100]}
              // components={{ Toolbar: CustomCustomerToolbar }}
              autoPageSize
              // disableColumnFilter
              disableColumnSelector
              disableDensitySelector
              // initialState={{
              //   aggregation: {
              //     model: {
              //       calc2: 'sum',
              //       year: 'sum',
              //     },
              //   },
              // }}
              componentsProps={
                {
                  // getRowId: loggedData.tech_id,
                  // toolbar: {
                  //   updateOnclick: () => {
                  //     setUpdateData((i) => i + 1);
                  //   },
                  //   filterOnClick: () => {
                  //     // handleFilterOpen();
                  //   },
                  //   // modalState: modalState,
                  // },
                }
              }
            />
            <Typography
              sx={{ fontWeight: 'bold' }}
              height={'3vh'}
              variant='h6'
              align='center'
              xs={{
                background: '#ebedf8',
                margin: '0 auto',
                width: '100%',
                justifyContent: 'center',
                alignItems: 'center',
                flexGrow: 1,
                textAlign: 'center',
                align: 'center',
              }}
            >
              Repair Tickets Response Time Per Tech Type
            </Typography>
            <DataGrid
              id='tickets_time_per_tech_type'
              sx={{
                ...gridStyle,
                width: '100%',
                height: '30vh',
              }}
              // rows={loggedData}
              rows={ticketTimesPerTechType}
              // getRowId={(row) => row?.tech_id}
              // rowCount={loggedTotalRows}
              // loading={loading}
              pagination
              // sortingMode='server'
              // filterMode='server'
              onSortModelChange={(model) => {
                // setLoggedPage(0);
                setTicketTimesPerTechTypeSort(model);
              }}
              // onFilterModelChange={(model) => {
              //   setLoggedPage(0);
              //   setLoggedFilter(model.quickFilterValues);
              // }}
              page={ticketTimesPerTechTypePage}
              // pageSize={loggedPageSize}
              // initialState={{
              //   pagination: {
              //     paginationModel: { pageSize: 5, page: 0 },
              //   },
              // }}
              // paginationMode='client'
              onPageChange={(newPage) => {
                setTicketTimesPerTechTypePage(newPage);
              }}
              onPageSizeChange={(newPageSize) => {
                setTicketTimesPerTechTypePage(0);
                setLoggedPageSize(newPageSize);
              }}
              columns={responseTimePerTechColumns}
              onRowClick={(params) => {}}
              // rowsPerPageOptions={[25, 50, 100]}
              // components={{ Toolbar: CustomCustomerToolbar }}
              autoPageSize
              // disableColumnFilter
              disableColumnSelector
              disableDensitySelector
              initialState={{
                aggregation: {
                  model: {
                    calc2: 'sum',
                    year: 'sum',
                  },
                },
              }}
              componentsProps={
                {
                  // getRowId: loggedData.tech_id,
                  // toolbar: {
                  //   updateOnclick: () => {
                  //     setUpdateData((i) => i + 1);
                  //   },
                  //   filterOnClick: () => {
                  //     // handleFilterOpen();
                  //   },
                  //   // modalState: modalState,
                  // },
                }
              }
            />
          </Grid>
          <Grid item xs={3.85}>
            <Typography
              sx={{ fontWeight: 'bold' }}
              height={'3vh'}
              variant='h6'
              align='center'
              xs={{
                background: '#ebedf8',
                margin: '0 auto',
                width: '100%',
                justifyContent: 'center',
                alignItems: 'center',
                flexGrow: 1,
                textAlign: 'center',
                align: 'center',
              }}
            >
              Tickets Per Tech
            </Typography>
            <DataGrid
              id='ticket_per_tech'
              sx={{
                ...gridStyle,
                // maxHeight: '100%',
                width: '100%',
                height: '114vh',
              }}
              rows={ticketsPerTech}
              // getRowId={(row) => row?.tech_id}
              // rowCount={loggedTotalRows}
              // loading={loading}
              pagination
              // sortingMode='server'
              // filterMode='server'
              onSortModelChange={(model) => {
                setTicketsPerTechPage(0);
                setTicketsPerTechSort(model);
              }}
              // onFilterModelChange={(model) => {
              //   setLoggedPage(0);
              //   setLoggedFilter(model.quickFilterValues);
              // }}
              page={ticketsPerTechPage}
              // pageSize={loggedPageSize}
              // initialState={{
              //   pagination: {
              //     paginationModel: { pageSize: 5, page: 0 },
              //   },
              // }}
              // paginationMode='client'
              onPageChange={(newPage) => {
                setTicketsPerTechPage(newPage);
              }}
              onPageSizeChange={(newPageSize) => {
                setTicketsPerTechPage(0);
                setLoggedPageSize(newPageSize);
              }}
              columns={ticketPerTechColumns}
              onRowClick={(params) => {}}
              // rowsPerPageOptions={[25, 50, 100]}
              // components={{ Toolbar: CustomCustomerToolbar }}
              autoPageSize
              // disableColumnFilter
              disableColumnSelector
              disableDensitySelector
              initialState={{
                aggregation: {
                  model: {
                    calc2: 'sum',
                    year: 'sum',
                  },
                },
              }}
              componentsProps={
                {
                  // getRowId: loggedData.tech_id,
                  // toolbar: {
                  //   updateOnclick: () => {
                  //     setUpdateData((i) => i + 1);
                  //   },
                  //   filterOnClick: () => {
                  //     // handleFilterOpen();
                  //   },
                  //   // modalState: modalState,
                  // },
                }
              }
            />
            <Typography
              sx={{ fontWeight: 'bold' }}
              height={'3vh'}
              variant='h6'
              align='center'
              xs={{
                background: '#ebedf8',
                margin: '0 auto',
                width: '100%',
                justifyContent: 'center',
                alignItems: 'center',
                flexGrow: 1,
                textAlign: 'center',
                align: 'center',
              }}
            >
              Customer Feedback
            </Typography>
            <DataGrid
              id='customer_feedback'
              sx={{
                ...gridStyle,
                // maxHeight: '100%',
                width: '100%',
                height: '30vh',
              }}
              rows={customerFeedback}
              // getRowId={(row) => row?.tech_id}
              // rowCount={loggedTotalRows}
              // loading={loading}
              pagination
              // sortingMode='server'
              // filterMode='server'
              onSortModelChange={(model) => {
                setCustomerFeedbackPage(0);
                setCustomerFeedbackSort(model);
              }}
              // onFilterModelChange={(model) => {
              //   setLoggedPage(0);
              //   setLoggedFilter(model.quickFilterValues);
              // }}
              page={customerFeedbackPage}
              // pageSize={loggedPageSize}
              // initialState={{
              //   pagination: {
              //     paginationModel: { pageSize: 5, page: 0 },
              //   },
              // }}
              // paginationMode='client'
              onPageChange={(newPage) => {
                setCustomerFeedbackPage(newPage);
              }}
              onPageSizeChange={(newPageSize) => {
                setCustomerFeedbackPage(0);
                setLoggedPageSize(newPageSize);
              }}
              columns={customerFeedbackColumns}
              onRowClick={(params) => {}}
              // rowsPerPageOptions={[25, 50, 100]}
              // components={{ Toolbar: CustomCustomerToolbar }}
              autoPageSize
              disableColumnFilter
              disableColumnSelector
              disableDensitySelector
              initialState={{
                aggregation: {
                  model: {
                    calc2: 'sum',
                    year: 'sum',
                  },
                },
              }}
              componentsProps={
                {
                  // getRowId: loggedData.tech_id,
                  // toolbar: {
                  //   updateOnclick: () => {
                  //     setUpdateData((i) => i + 1);
                  //   },
                  //   filterOnClick: () => {
                  //     // handleFilterOpen();
                  //   },
                  //   // modalState: modalState,
                  // },
                }
              }
            />
          </Grid>
          <Grid item xs={3.85}>
            <Typography
              sx={{ fontWeight: 'bold' }}
              height={'3vh'}
              variant='h6'
              align='center'
              xs={{
                background: '#ebedf8',
                margin: '0 auto',
                width: '100%',
                justifyContent: 'center',
                alignItems: 'center',
                flexGrow: 1,
                textAlign: 'center',
                align: 'center',
              }}
            >
              Tickets Per Invoice Type For Repair Tickets
            </Typography>
            <DataGrid
              id='invoice_type_for_repair'
              sx={{
                ...gridStyle,
                // maxHeight: '100%',
                width: '100%',
                height: '50vh',
              }}
              rows={invoiceType}
              // getRowId={(row) => row?.tech_id}
              // rowCount={loggedTotalRows}
              // loading={loading}
              pagination
              // sortingMode='server'
              // filterMode='server'
              onSortModelChange={(model) => {
                setInvoiceTypePage(0);
                setInvoiceTypeSort(model);
              }}
              // onFilterModelChange={(model) => {
              //   setLoggedPage(0);
              //   setLoggedFilter(model.quickFilterValues);
              // }}
              page={invoiceTypePage}
              // pageSize={loggedPageSize}
              // initialState={{
              //   pagination: {
              //     paginationModel: { pageSize: 5, page: 0 },
              //   },
              // }}
              // paginationMode='client'
              onPageChange={(newPage) => {
                setInvoiceTypePage(newPage);
              }}
              onPageSizeChange={(newPageSize) => {
                setInvoiceTypePage(0);
                setLoggedPageSize(newPageSize);
              }}
              columns={invoiceTypeForRepairColumns}
              onRowClick={(params) => {}}
              // rowsPerPageOptions={[25, 50, 100]}
              // components={{ Toolbar: CustomCustomerToolbar }}
              autoPageSize
              // disableColumnFilter
              disableColumnSelector
              disableDensitySelector
              initialState={{
                aggregation: {
                  model: {
                    calc2: 'sum',
                    year: 'sum',
                  },
                },
              }}
              componentsProps={
                {
                  // getRowId: loggedData.tech_id,
                  // toolbar: {
                  //   updateOnclick: () => {
                  //     setUpdateData((i) => i + 1);
                  //   },
                  //   filterOnClick: () => {
                  //     // handleFilterOpen();
                  //   },
                  //   // modalState: modalState,
                  // },
                }
              }
            />
            <Typography
              sx={{ fontWeight: 'bold' }}
              height={'3vh'}
              variant='h6'
              align='center'
              xs={{
                background: '#ebedf8',
                margin: '0 auto',
                width: '100%',
                justifyContent: 'center',
                alignItems: 'center',
                flexGrow: 1,
                textAlign: 'center',
                align: 'center',
              }}
            >
              Tickets Per Cabinet Type Repair Tickets
            </Typography>
            {/* {console.log('CABINETS', perCabinet)} */}
            <DataGrid
              id='per_cabinet_type_repair'
              sx={{
                ...gridStyle,
                // maxHeight: '100%',
                width: '100%',
                height: '60vh',
              }}
              rows={perCabinet}
              // getRowId={(row) => row?.tech_id}
              // rowCount={loggedTotalRows}
              // loading={loading}
              pagination
              // sortingMode='server'
              // filterMode='server'
              onSortModelChange={(model) => {
                setPerCabinetPage(0);
                setPerCabinetSort(model);
              }}
              // onFilterModelChange={(model) => {
              //   setLoggedPage(0);
              //   setLoggedFilter(model.quickFilterValues);
              // }}
              page={perCabinetPage}
              // pageSize={loggedPageSize}
              // initialState={{
              //   pagination: {
              //     paginationModel: { pageSize: 5, page: 0 },
              //   },
              // }}
              // paginationMode='client'
              onPageChange={(newPage) => {
                setPerCabinetPage(newPage);
              }}
              onPageSizeChange={(newPageSize) => {
                setPerCabinetPage(0);
                setLoggedPageSize(newPageSize);
              }}
              columns={perCabinetTypeRepairColumns}
              onRowClick={(params) => {}}
              // rowsPerPageOptions={[25, 50, 100]}
              // components={{ Toolbar: CustomCustomerToolbar }}
              autoPageSize
              disableColumnFilter
              disableColumnSelector
              disableDensitySelector
              initialState={{
                aggregation: {
                  model: {
                    calc2: 'sum',
                    year: 'sum',
                  },
                },
              }}
              componentsProps={
                {
                  // getRowId: loggedData.tech_id,
                  // toolbar: {
                  //   updateOnclick: () => {
                  //     setUpdateData((i) => i + 1);
                  //   },
                  //   filterOnClick: () => {
                  //     // handleFilterOpen();
                  //   },
                  //   // modalState: modalState,
                  // },
                }
              }
            />
            <Typography
              sx={{ fontWeight: 'bold' }}
              height={'3vh'}
              variant='h6'
              align='center'
              xs={{
                background: '#ebedf8',
                margin: '0 auto',
                width: '100%',
                justifyContent: 'center',
                alignItems: 'center',
                flexGrow: 1,
                textAlign: 'center',
                align: 'center',
              }}
            >
              Tickets Per Invoice Type Repair Tickets
            </Typography>
            <DataGrid
              id='tickets_per_repair_invoice'
              sx={{
                ...gridStyle,
                // maxHeight: '100%',
                width: '100%',
                height: '30vh',
              }}
              rows={perRepairInvoice}
              // getRowId={(row) => row?.tech_id}
              // rowCount={loggedTotalRows}
              // loading={loading}
              pagination
              // sortingMode='server'
              // filterMode='server'
              onSortModelChange={(model) => {
                setPerRepairInvoicePage(0);
                setPerRepairInvoiceSort(model);
              }}
              // onFilterModelChange={(model) => {
              //   setLoggedPage(0);
              //   setLoggedFilter(model.quickFilterValues);
              // }}
              page={perRepairInvoicePage}
              // pageSize={loggedPageSize}
              // initialState={{
              //   pagination: {
              //     paginationModel: { pageSize: 5, page: 0 },
              //   },
              // }}
              // paginationMode='client'
              onPageChange={(newPage) => {
                setPerRepairInvoicePage(newPage);
              }}
              onPageSizeChange={(newPageSize) => {
                setPerRepairInvoicePage(0);
                setLoggedPageSize(newPageSize);
              }}
              columns={perInvoiceTypeRepairColumns}
              onRowClick={(params) => {}}
              // rowsPerPageOptions={[25, 50, 100]}
              // components={{ Toolbar: CustomCustomerToolbar }}
              autoPageSize
              disableColumnFilter
              disableColumnSelector
              disableDensitySelector
              initialState={{
                aggregation: {
                  model: {
                    calc2: 'sum',
                    year: 'sum',
                  },
                },
              }}
              componentsProps={
                {
                  // getRowId: loggedData.tech_id,
                  // toolbar: {
                  //   updateOnclick: () => {
                  //     setUpdateData((i) => i + 1);
                  //   },
                  //   filterOnClick: () => {
                  //     // handleFilterOpen();
                  //   },
                  //   // modalState: modalState,
                  // },
                }
              }
            />
          </Grid>
          <Grid item xs={12} align='center'>
            <Typography
              sx={{ fontWeight: 'bold' }}
              variant='h6'
              xs={{
                background: '#ebedf8',

                width: '100% !important',
                // justifyContent: 'center',
                // alignItems: 'center',

                textAlign: 'center',
                align: 'center',
              }}
            >
              Repair Tickets Response Time Per Region
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <DataGrid
              id='ticket_times_per_region'
              sx={{ ...gridStyle, height: '35vh', width: '100%' }}
              rows={timesPerRegion}
              // rowCount={totalRows}
              // loading={loading}
              pagination
              // sortingMode='server'
              // filterMode='server'
              onSortModelChange={(model) => {
                setPage(0);
                setSort(model);
              }}
              onFilterModelChange={(model) => {
                setPage(0);
                setFilter(model.quickFilterValues);
              }}
              page={page}
              // pageSize={pageSize}
              // paginationMode='server'
              onPageChange={(newPage) => {
                setPage(newPage);
              }}
              onPageSizeChange={(newPageSize) => {
                setPage(0);
                setPageSize(newPageSize);
              }}
              columns={RepairTicketsResponseTimePerRegionColumns}
              onRowClick={(params) => {}}
              //   onRowDoubleClick={(params) => {
              //     setRowData(params.row);
              //     // getMyRowData(params.row);
              //     // setEditOrSave('editMode');
              //   }}
              // rowsPerPageOptions={[25, 50, 100]}
              // components={{ Toolbar: CustomCustomerToolbar }}
              // disableColumnFilter
              autoPageSize
              disableColumnSelector
              disableDensitySelector
              // componentsProps={{
              //   toolbar: {
              //     updateOnclick: () => {
              //       setUpdateData((i) => i + 1);
              //     },
              //     filterOnClick: () => {
              //       // handleFilterOpen();
              //     },
              //     // modalState: modalState,
              //   },
              // }}
            />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default TicketingReport;
